module.exports = __webpack_public_path__ + "static/media/unplaced-order.0e26697e.svg";